import extend from 'lodash/extend';

export default class StoreModel {
  constructor(store) {
    if (store) {
      extend(this, store);
    } else {
      this._initDefaults();
    }
  }

  _initDefaults() {
    this.campaigns = [];
    this.name = ''
    this.description = '';
    this.banner_bg_color = '#FFFFFF';
    this.is_tag_based = false;
    this.is_online = false;
    this.tags = [];
    this.banner_image_data_uri = null;
    this.url = '';
    this.domain_id = 'VS';
    this.sort_by = 'MANUAL';
    this.enable_sort_and_filter = true;
  }
}